import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54c89788")

_pushScopeId("data-v-54c89788")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "繰返し", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("繰返しタイプ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("繰返し間隔 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_select_box = _resolveComponent("select-box")
  const _component_vue_label = _resolveComponent("vue-label")
  const _component_validate_edit_box_number = _resolveComponent("validate-edit-box-number")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_vue_label, {
      class: "vue-content-edit-box",
      required: true
    }, {
      label: _withId(() => [
        _hoisted_2
      ]),
      content: _withId(() => [
        _createVNode(_component_select_box, {
          items: _ctx.intervalTypes,
          modelValue: _ctx.intervalType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.intervalType = $event))
        }, null, 8, ["items", "modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_validate_edit_box_number, {
      class: "vue-content-edit-box",
      title: "繰返し間隔",
      placeholder: "間隔(数値)",
      validation: _ctx.submitted ? _ctx.intervalError : undefined,
      required: true,
      readonly: _ctx.intervalType==='once',
      modelValue: _ctx.interval,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.interval = $event))
    }, {
      default: _withId(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["validation", "readonly", "modelValue"])
  ]))
})